<div class="energy-map">
  <div class="body-display">
    <div id="leaflet-map-component" class="leafletMapComponent" #mapContainer></div>

    <div class="address-search">
      <app-address-search [municipality]="municipalityToSearch" (selectEvent)="addressNavigate($event)"></app-address-search>
    </div>

    <div class="header-controls">
      <app-map-header-controls></app-map-header-controls>
    </div>

    <div class="side-controls">
      <app-map-side-controls></app-map-side-controls>
    </div>

    <app-description
      *ngIf="showDescription"
      class="app-desc"
      [assets]="selectedMarkers"
      [isModalVisible]="showDescription"
      (saveEmitter)="refreshClusters($event)"
      (closeEvent)="showDescription = false; removeSelectedBuilding()"
      [IsEditBuilding]="IsEditBuilding"
    ></app-description>

    <app-edit-building></app-edit-building>
  </div>
</div>
<app-overlay-loader *ngIf="isLoading"></app-overlay-loader>
